import React from 'react'
import classes from "./Header.module.css"

const Header = ({title, headerStyle={}}) => {
  return (
    <div className={classes.dheader} style={headerStyle} >{title}</div>
  )
}

export default Header